<template>
  <div>
    
    <SettingsAccountDetails :account="account"/>

    <h2>Notifications</h2>
    <SettingsAccountNotifications :account="account"/>

    <pre class="debug" v-show="debugMode">{{ account }}</pre>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<script>
import { mapState } from 'vuex'
import SettingsAccountDetails from '@/components/SettingsAccountDetails.vue'
import SettingsAccountNotifications from '@/components/SettingsAccountNotifications.vue'
export default {
  name: 'accountSettings',
  components: {
    SettingsAccountDetails,
    SettingsAccountNotifications,
  },
  props: {
    account: {
      type: Object,
      required: true
    }
  },
  computed: mapState([
    'debugMode'
  ])
}
</script>
